import styled from 'styled-components'

export const SectionGlobal = styled.section`
background-color: white;
display: flex;
justify-content: space-evenly;
align-items: center;
@media (min-width: 201px) and (max-width: 500px) {
    flex-direction: column;
}
`

export const SectionTabela = styled.section`
margin-top: 1rem;
width: 50%;
@media (min-width: 201px) and (max-width: 500px) {
    width: 100%;
}
`

export const DivTabelaTitulo = styled.div`
display: flex;
p {
    font-size: 1.4rem;
    text-align: start;
    color: white;
    width: 100%;
    height: 4.5vh;
    background-image: linear-gradient(135deg, rgb(24, 24, 27) 0%, rgba(24, 24, 27, 0.8) 100%);
    padding-top: 0.1rem;
    padding-left: 0.5rem;
    font-weight: 600;
}
@media (min-width: 201px) and (max-width: 500px) {
   p {
    font-size: 0.7rem;
    height: 3vh;
   }
}
`
export const DivTabelaConteudo = styled.div`
margin-top: 1rem;
display: flex;
font-size: 1.1rem;
text-align: start;
p {
    width: 100%;
    padding-left: 0.5rem;
}
@media (min-width: 201px) and (max-width: 500px) {
    font-size: 0.6rem;
}
`
export const DivAplicacoes = styled.div`
p {
    font-weight: 600;
}
margin-top: 2.5rem;
display: flex;
flex-direction: column;
align-items: flex-start;
text-align: start;
ul {
    margin-left: 1.5rem;
    margin-top: 0.5rem;
}
`
export const ImgCores = styled.img `
margin-top: 1.5rem;
display: flex;
align-items: flex-start;
@media (min-width: 201px) and (max-width: 500px) {
    width: 100%;
}
@media (min-width: 501px) and (max-width: 900px) {
    position: relative;
    right: 1.5rem;
}
`

export const ImgDecor = styled.img`
width: 45%;
height: 45vh;
border-radius: 10px; 
@media (min-width: 201px) and (max-width: 500px) {
    width: 90%;
    height: 35vh;
}
@media (min-width: 501px) and (max-width: 900px) {
    width: 40%;
    height: 25vh;
}
`